import axios, { apiBaseURL } from './axios'

const contanceBaseURL = `${apiBaseURL}/constance`

export default class ConstanceApi {
  static getConstance(names?: string | string[]): Promise<IConstance[]> {
    if (!names) return axios.get(`${contanceBaseURL}`)
    if (Array.isArray(names)) {
      const qs = names.map((n) => `name=${encodeURIComponent(n)}`).join('&')
      return axios.get(`${contanceBaseURL}?${qs}`)
    }
    return axios.get(`${contanceBaseURL}?name=${encodeURIComponent(names)}`)
  }
}
